import React from "react";

import { CloseModal } from "@routes/IconeSvg";

/**
 *
 * @param {Object} props
 * @param {(e: any) => void} props.onClick
 * @property
 * @returns
 */
/**
 * @property {JSX.Element=} customClass
 */
function ButtonCloseModal({ onClick, customClass = "" }) {
  return (
    <button
      type="button"
      className={`arh-absolute arh-right-8 arh-top-8 arh-z-10 arh-flex arh-cursor-pointer arh-items-center arh-justify-center arh-rounded-full arh-border-0 arh-bg-transparent arh-p-3 hover:arh-bg-gray-200 active:arh-bg-greyActive mobile-768:arh-right-4 mobile-768:arh-top-6 ${customClass}`}
      onClick={onClick}
    >
      <CloseModal />
    </button>
  );
}

export default ButtonCloseModal;
